import React from "react";
import {
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
} from "../../../../components/Component";
import { Badge } from "reactstrap";
import moment from "moment";
import PartnerStatusBadge from "../../../../components/features/medical-partner-admin/PartnerStatusBadge";
import { userRoleBadgeClass } from "./helpers";
import "./medical-partner-details.css";

const PartnerDetailPageHeader = ({
  inPanel,
  organizationName,
  partner,
  user,
  onBreadcrumbPartners,
  onEditProfile,
  onCloseOrBack,
  canEditProfile = false,
}) => {
  return (
    <>
      <nav aria-label="breadcrumb" className={`mb-3 ${inPanel ? "px-1" : ""}`}>
        <ol className="breadcrumb breadcrumb-pipe mb-0">
          <li className="breadcrumb-item">
            <a href="#partners" onClick={(e) => { e.preventDefault(); onBreadcrumbPartners(); }}>
              Medical partners
            </a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {organizationName || "Partner details"}
          </li>
        </ol>
      </nav>

      <BlockHead size="sm">
        <BlockBetween>
          <BlockHeadContent>
            <BlockTitle tag="h3" page>
              Medical partner / <strong className="text-primary">{organizationName || "N/A"}</strong>
            </BlockTitle>
            <BlockDes className="text-soft">
              <div className="mp-detail-meta-row">
                <span>
                  ID : <span className="text-base">{partner._id}</span>
                </span>
                <span>
                  Workflow: <PartnerStatusBadge status={partner.status} />
                </span>
                <span>
                  Created :{" "}
                  <span className="text-base">
                    {partner.createdAt ? moment(partner.createdAt).format("DD/MM/YYYY") : "N/A"}
                  </span>
                </span>
                {user ? (
                  <span className="d-inline-flex align-items-center flex-wrap">
                    Login role :
                    <Badge className={`badge-dim badge-${userRoleBadgeClass(user.role)}`} pill>
                      {user.role || "Not set"}
                    </Badge>
                    {user.role === "admin" ? (
                      <Badge color="info" pill className="ms-1">
                        Admin preserved
                      </Badge>
                    ) : null}
                  </span>
                ) : null}
              </div>
            </BlockDes>
          </BlockHeadContent>
          <BlockHeadContent>
            <div className="d-flex flex-wrap align-items-center justify-content-end gap-2">
              {canEditProfile ? (
                <Button color="primary" type="button" className="d-inline-flex" onClick={onEditProfile}>
                  <Icon name="edit-alt-fill" className="mr-1" />
                  <span>Edit</span>
                </Button>
              ) : null}
              <Button
                color="light"
                outline
                className="bg-white d-none d-sm-inline-flex"
                type="button"
                onClick={onCloseOrBack}
              >
                <Icon name="arrow-left" />
                <span>{inPanel ? "Close" : "Back"}</span>
              </Button>
            </div>
          </BlockHeadContent>
        </BlockBetween>
      </BlockHead>
    </>
  );
};

export default PartnerDetailPageHeader;
